/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyModelSearchResultModel } from '../../models/lobby-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface LobbySearchPost$Params {
      body?: SearchRequestModel
}

export function lobbySearchPost(http: HttpClient, rootUrl: string, params?: LobbySearchPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, lobbySearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<LobbyModelSearchResultModel>;
    })
  );
}

lobbySearchPost.PATH = '/Lobby/Search';
